import type {
  NotificationEventType,
  NotificationPreferenceDto,
} from "@mimber/schema"
import { CommunicationChannel } from "@mimber/schema"

/**
 * Props for the NotificationPreferenceMatrix component.
 */
export interface NotificationPreferenceMatrixProps {
  /** Section title, e.g. "Membership Alerts" */
  title: string
  /** Effective preferences for a single NotificationCategory */
  preferences: NotificationPreferenceDto[]
  /** Invoked when the user toggles a single (eventType, channel) switch */
  onToggle: (
    eventType: NotificationEventType,
    channel: CommunicationChannel,
    enabled: boolean
  ) => void
  /** `${eventType}:${channel}` key for the switch currently saving, if any */
  pendingKey?: string | null
}

/**
 * Internal row type for the Ant Design Table.
 */
export interface NotificationMatrixRow {
  key: string
  eventType: NotificationEventType
  label: string
  description: string
  channels: Partial<
    Record<CommunicationChannel, { enabled: boolean; locked: boolean }>
  >
}

/** Builds the `${eventType}:${channel}` key used to identify a pending switch. */
export const buildPendingKey = (
  eventType: NotificationEventType,
  channel: CommunicationChannel
): string => `${eventType}:${channel}`
